import { render, staticRenderFns } from "./ImportTradeIn.vue?vue&type=template&id=4797cff4"
import script from "./ImportTradeIn.vue?vue&type=script&lang=js"
export * from "./ImportTradeIn.vue?vue&type=script&lang=js"
import style0 from "./ImportTradeIn.vue?vue&type=style&index=0&id=4797cff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports